import React, { useMemo, useState } from "react";

const EXPERIENCE_BRAND_COLOR = "#B86FFF";
const spokesData = {
    research: [
    { links: [
        { label: "Market Analysis", url: "https://www.twodots.cloud/UseExecution", content: "Market Analysis content goes here. This section provides comprehensive market research and competitive analysis." },
        { label: "Competitor Research", url: "https://www.twodots.cloud/UseExecution", content: "Competitor Research insights. Deep dive into competitor strategies and market positioning." }
    ]},
    { links: [
        { label: "Customer Insights 🌟", url: "https://www.twodots.cloud/CompanyResearch", content: "Customer Insights dashboard. Understanding customer behavior and preferences." },
        { label: "Sentiment Analysis", url: "https://www.twodots.cloud/UseExecution", content: "Sentiment Analysis tools. Track and analyze customer sentiment across channels." }
    ]},
    { links: [
        { label: "Survey Results", url: "https://www.twodots.cloud/UseExecution", content: "Survey Results and analytics. Comprehensive survey data and insights." },
        { label: "Focus Groups", url: "https://www.twodots.cloud/UseExecution", content: "Focus Groups findings. Qualitative research and customer feedback." }
    ]},
    { links: [
        { label: "Analytics Dashboard", url: "https://www.twodots.cloud/UseExecution", content: "Analytics Dashboard overview. Real-time data visualization and reporting." },
        { label: "Performance Metrics", url: "https://www.twodots.cloud/UseExecution", content: "Performance Metrics tracking. KPIs and success indicators." }
    ]},
    { links: [
        { label: "Trend Forecasting", url: "https://www.twodots.cloud/UseExecution", content: "Trend Forecasting models. Identify emerging patterns to guide roadmap and investment." },
        { label: "Pricing Research", url: "https://www.twodots.cloud/UseExecution", content: "Pricing Research studies. Elasticity tests, WTP surveys, and competitive pricing maps." }
    ]},
    { links: [
        { label: "Product–Market Fit", url: "https://www.twodots.cloud/UseExecution", content: "PMF Assessment. Sean Ellis score tracking and cohort-level retention analysis." },
        { label: "Persona Development", url: "https://www.twodots.cloud/UseExecution", content: "Persona Development playbooks. Evidence-based archetypes and jobs-to-be-done." }
    ]},
    { links: [
        { label: "A/B Test Results", url: "https://www.twodots.cloud/UseExecution", content: "A/B Test repository. Hypotheses, variants, uplift, and statistical power notes." },
        { label: "Cohort Analysis", url: "https://www.twodots.cloud/UseExecution", content: "Cohort Analysis explorer. Retention curves and lifecycle insights." }
    ]},
    { links: [
        { label: "Churn Analysis", url: "https://www.twodots.cloud/UseExecution", content: "Churn Analysis dashboard. Leading indicators and save-offer playbooks." },
        { label: "TAM/SAM/SOM", url: "https://www.twodots.cloud/UseExecution", content: "Market Sizing. TAM/SAM/SOM models with sourcing assumptions." }
    ]},
    { links: [
        { label: "Voice of Customer", url: "https://www.twodots.cloud/UseExecution", content: "VoC Repository. Thematic tagging of feedback from tickets, NPS, and reviews." },
        { label: "Win/Loss Analysis", url: "https://www.twodots.cloud/UseExecution", content: "Win/Loss interviews. Drivers of selection and competitive battlecards." }
    ]},
    { links: [
        { label: "Regulatory Scan", url: "https://www.twodots.cloud/UseExecution", content: "Regulatory Landscape. Compliance requirements and horizon scanning." },
        { label: "Tech Landscape", url: "https://www.twodots.cloud/UseExecution", content: "Technology Landscape review. Vendor matrices and capability gaps." }
    ]},
    // duplicate set (by design)
    { links: [
        { label: "Market Analysis", url: "https://www.twodots.cloud/UseExecution", content: "Market Analysis content goes here. This section provides comprehensive market research and competitive analysis." },
        { label: "Competitor Research", url: "https://www.twodots.cloud/UseExecution", content: "Competitor Research insights. Deep dive into competitor strategies and market positioning." }
    ]},
    { links: [
        { label: "Customer Insights 🌟", url: "https://www.twodots.cloud/CompanyResearch", content: "Customer Insights dashboard. Understanding customer behavior and preferences." },
        { label: "Sentiment Analysis", url: "https://www.twodots.cloud/UseExecution", content: "Sentiment Analysis tools. Track and analyze customer sentiment across channels." }
    ]},
    { links: [
        { label: "Survey Results", url: "https://www.twodots.cloud/UseExecution", content: "Survey Results and analytics. Comprehensive survey data and insights." },
        { label: "Focus Groups", url: "https://www.twodots.cloud/UseExecution", content: "Focus Groups findings. Qualitative research and customer feedback." }
    ]},
    { links: [
        { label: "Analytics Dashboard", url: "https://www.twodots.cloud/UseExecution", content: "Analytics Dashboard overview. Real-time data visualization and reporting." },
        { label: "Performance Metrics", url: "https://www.twodots.cloud/UseExecution", content: "Performance Metrics tracking. KPIs and success indicators." }
    ]},
    { links: [
        { label: "Trend Forecasting", url: "https://www.twodots.cloud/UseExecution", content: "Trend Forecasting models. Identify emerging patterns to guide roadmap and investment." },
        { label: "Pricing Research", url: "https://www.twodots.cloud/UseExecution", content: "Pricing Research studies. Elasticity tests, WTP surveys, and competitive pricing maps." }
    ]},
    { links: [
        { label: "Product–Market Fit", url: "https://www.twodots.cloud/UseExecution", content: "PMF Assessment. Sean Ellis score tracking and cohort-level retention analysis." },
        { label: "Persona Development", url: "https://www.twodots.cloud/UseExecution", content: "Persona Development playbooks. Evidence-based archetypes and jobs-to-be-done." }
    ]},
    { links: [
        { label: "A/B Test Results", url: "https://www.twodots.cloud/UseExecution", content: "A/B Test repository. Hypotheses, variants, uplift, and statistical power notes." },
        { label: "Cohort Analysis", url: "https://www.twodots.cloud/UseExecution", content: "Cohort Analysis explorer. Retention curves and lifecycle insights." }
    ]},
    { links: [
        { label: "Churn Analysis", url: "https://www.twodots.cloud/UseExecution", content: "Churn Analysis dashboard. Leading indicators and save-offer playbooks." },
        { label: "TAM/SAM/SOM", url: "https://www.twodots.cloud/UseExecution", content: "Market Sizing. TAM/SAM/SOM models with sourcing assumptions." }
    ]},
    { links: [
        { label: "Voice of Customer", url: "https://www.twodots.cloud/UseExecution", content: "VoC Repository. Thematic tagging of feedback from tickets, NPS, and reviews." },
        { label: "Win/Loss Analysis", url: "https://www.twodots.cloud/UseExecution", content: "Win/Loss interviews. Drivers of selection and competitive battlecards." }
    ]},
    { links: [
        { label: "Regulatory Scan", url: "https://www.twodots.cloud/UseExecution", content: "Regulatory Landscape. Compliance requirements and horizon scanning." },
        { label: "Tech Landscape", url: "https://www.twodots.cloud/UseExecution", content: "Technology Landscape review. Vendor matrices and capability gaps." }
    ]}
  ],
  workflows: [
    { links: [
        { label: "n8n Automation", url: "https://www.twodots.cloud/UseExecution", content: "n8n Automation platform. Build powerful workflow automations without code." },
        { label: "Process Builder", url: "https://www.twodots.cloud/UseExecution", content: "Process Builder interface. Design and optimize business processes." }
    ]},
    { links: [
        { label: "Find Jobs 🌟", url: "https://www.twodots.cloud/FindJobs", content: "Collect Info and Summarize to find jobs." },
        { label: "Webhook Manager", url: "https://www.twodots.cloud/UseExecution", content: "Webhook Manager. Configure and monitor webhook integrations." }
    ]},
    { links: [
        { label: "Data Pipeline", url: "https://www.twodots.cloud/UseExecution", content: "Data Pipeline orchestration. ETL processes and data flow management." },
        { label: "ETL Flows", url: "https://www.twodots.cloud/UseExecution", content: "ETL Flows builder. Extract, transform, and load data workflows." }
    ]},
    { links: [
        { label: "Workflow Studio", url: "https://www.twodots.cloud/UseExecution", content: "Workflow Studio. Visual workflow design and testing environment." },
        { label: "Template Library", url: "https://www.twodots.cloud/UseExecution", content: "Template Library. Pre-built workflow templates for common use cases." }
    ]},
    { links: [
        { label: "Approval Flows", url: "https://www.twodots.cloud/UseExecution", content: "Approval Workflows. Multi-step reviews with SLA gates and audit trails." },
        { label: "Incident Response", url: "https://www.twodots.cloud/UseExecution", content: "Incident Response runbooks. Pager, escalation, and postmortem automation." }
    ]},
    { links: [
        { label: "Employee Onboarding", url: "https://www.twodots.cloud/UseExecution", content: "Onboarding Automation. Accounts, permissions, and welcome sequences." },
        { label: "SLA Monitor", url: "https://www.twodots.cloud/UseExecution", content: "SLA Monitoring. Breach detection, alerts, and auto-remediation steps." }
    ]},
    { links: [
        { label: "Notification Router", url: "https://www.twodots.cloud/UseExecution", content: "Notification Routing. Channel rules for email, SMS, chat, and push." },
        { label: "Data Sync", url: "https://www.twodots.cloud/UseExecution", content: "Data Sync jobs. Bidirectional sync across CRM, billing, and support." }
    ]},
    { links: [
        { label: "CRM Updates", url: "https://www.twodots.cloud/UseExecution", content: "CRM Automation. Lead scoring, enrichment, and lifecycle stages." },
        { label: "Billing Automation", url: "https://www.twodots.cloud/UseExecution", content: "Billing Workflows. Usage metering, invoicing, and dunning sequences." }
    ]},
    { links: [
        { label: "QA Gatekeeper", url: "https://www.twodots.cloud/UseExecution", content: "Quality Gatekeeper. Pre-release checks, test runs, and release toggles." },
        { label: "Compliance Checks", url: "https://www.twodots.cloud/UseExecution", content: "Compliance Workflows. PII handling, GDPR/CCPA requests automation." }
    ]},
    { links: [
        { label: "Inventory Replenishment", url: "https://www.twodots.cloud/UseExecution", content: "Inventory Replenishment. Forecasting and purchase order triggers." },
        { label: "Supply Chain Tracker", url: "https://www.twodots.cloud/UseExecution", content: "Supply Chain Tracker. Milestone alerts and exception management." }
    ]},
    // duplicate set (by design)
    { links: [
        { label: "n8n Automation", url: "https://www.twodots.cloud/UseExecution", content: "n8n Automation platform. Build powerful workflow automations without code." },
        { label: "Process Builder", url: "https://www.twodots.cloud/UseExecution", content: "Process Builder interface. Design and optimize business processes." }
    ]},
    { links: [
        { label: "Find Jobs 🌟", url: "https://www.twodots.cloud/FindJobs", content: "Collect Info and Summarize to find jobs."  },
        { label: "Webhook Manager", url: "https://www.twodots.cloud/UseExecution", content: "Webhook Manager. Configure and monitor webhook integrations." }
    ]},
    { links: [
        { label: "Data Pipeline", url: "https://www.twodots.cloud/UseExecution", content: "Data Pipeline orchestration. ETL processes and data flow management." },
        { label: "ETL Flows", url: "https://www.twodots.cloud/UseExecution", content: "ETL Flows builder. Extract, transform, and load data workflows." }
    ]},
    { links: [
        { label: "Workflow Studio", url: "https://www.twodots.cloud/UseExecution", content: "Workflow Studio. Visual workflow design and testing environment." },
        { label: "Template Library", url: "https://www.twodots.cloud/UseExecution", content: "Template Library. Pre-built workflow templates for common use cases." }
    ]},
    { links: [
        { label: "Approval Flows", url: "https://www.twodots.cloud/UseExecution", content: "Approval Workflows. Multi-step reviews with SLA gates and audit trails." },
        { label: "Incident Response", url: "https://www.twodots.cloud/UseExecution", content: "Incident Response runbooks. Pager, escalation, and postmortem automation." }
    ]},
    { links: [
        { label: "Employee Onboarding", url: "https://www.twodots.cloud/UseExecution", content: "Onboarding Automation. Accounts, permissions, and welcome sequences." },
        { label: "SLA Monitor", url: "https://www.twodots.cloud/UseExecution", content: "SLA Monitoring. Breach detection, alerts, and auto-remediation steps." }
    ]},
    { links: [
        { label: "Notification Router", url: "https://www.twodots.cloud/UseExecution", content: "Notification Routing. Channel rules for email, SMS, chat, and push." },
        { label: "Data Sync", url: "https://www.twodots.cloud/UseExecution", content: "Data Sync jobs. Bidirectional sync across CRM, billing, and support." }
    ]},
    { links: [
        { label: "CRM Updates", url: "https://www.twodots.cloud/UseExecution", content: "CRM Automation. Lead scoring, enrichment, and lifecycle stages." },
        { label: "Billing Automation", url: "https://www.twodots.cloud/UseExecution", content: "Billing Workflows. Usage metering, invoicing, and dunning sequences." }
    ]},
    { links: [
        { label: "QA Gatekeeper", url: "https://www.twodots.cloud/UseExecution", content: "Quality Gatekeeper. Pre-release checks, test runs, and release toggles." },
        { label: "Compliance Checks", url: "https://www.twodots.cloud/UseExecution", content: "Compliance Workflows. PII handling, GDPR/CCPA requests automation." }
    ]},
    { links: [
        { label: "Inventory Replenishment", url: "https://www.twodots.cloud/UseExecution", content: "Inventory Replenishment. Forecasting and purchase order triggers." },
        { label: "Supply Chain Tracker", url: "https://www.twodots.cloud/UseExecution", content: "Supply Chain Tracker. Milestone alerts and exception management." }
    ]}
  ],
  knowledge: [
    { links: [
        { label: "Document Library", url: "https://www.twodots.cloud/UseExecution", content: "Document Library. Centralized repository of all documentation." },
        { label: "Knowledge Base", url: "https://www.twodots.cloud/UseExecution", content: "Knowledge Base. Searchable articles and guides." }
    ]},
    { links: [
        { label: "Training Center", url: "https://www.twodots.cloud/UseExecution", content: "Training Center. Interactive courses and learning materials." },
        { label: "Best Practices", url: "https://www.twodots.cloud/UseExecution", content: "Best Practices guide. Industry standards and recommendations." }
    ]},
    { links: [
        { label: "Resource Hub", url: "https://www.twodots.cloud/UseExecution", content: "Resource Hub. Tools, templates, and helpful resources." },
        { label: "Learning Paths", url: "https://www.twodots.cloud/UseExecution", content: "Learning Paths. Structured courses for skill development." }
    ]},
    { links: [
        { label: "Documentation", url: "https://www.twodots.cloud/UseExecution", content: "Documentation portal. Technical specs and API guides." },
        { label: "API Reference", url: "https://www.twodots.cloud/UseExecution", content: "API Reference. Complete API documentation and examples." }
    ]},
    { links: [
        { label: "Runbooks", url: "https://www.twodots.cloud/UseExecution", content: "Operational Runbooks. Step-by-step procedures for common tasks and incidents." },
        { label: "FAQs", url: "https://www.twodots.cloud/UseExecution", content: "Frequently Asked Questions. Curated answers to common queries." }
    ]},
    { links: [
        { label: "Architecture Diagrams", url: "https://www.twodots.cloud/UseExecution", content: "Architecture Library. System context, data flows, and component diagrams." },
        { label: "Style Guide", url: "https://www.twodots.cloud/UseExecution", content: "Editorial & Design Style Guide. Tone, typography, and UI conventions." }
    ]},
    { links: [
        { label: "Glossary", url: "https://www.twodots.cloud/UseExecution", content: "Company Glossary. Shared vocabulary and domain definitions." },
        { label: "Release Notes", url: "https://www.twodots.cloud/UseExecution", content: "Release Notes. Version changes, features, and fixes." }
    ]},
    { links: [
        { label: "ADRs", url: "https://www.twodots.cloud/UseExecution", content: "Architecture Decision Records. Context, decision, and consequences." },
        { label: "Onboarding Guide", url: "https://www.twodots.cloud/UseExecution", content: "New Hire Onboarding. First 90 days plan and learning checkpoints." }
    ]},
    { links: [
        { label: "Security Policies", url: "https://www.twodots.cloud/UseExecution", content: "Security Policies. Access control, secrets, and incident reporting." },
        { label: "Data Governance", url: "https://www.twodots.cloud/UseExecution", content: "Data Governance. Catalog, lineage, and quality standards." }
    ]},
    { links: [
        { label: "Partner Playbooks", url: "https://www.twodots.cloud/UseExecution", content: "Partner Playbooks. GTM motions, enablement, and integration guides." },
        { label: "Customer Stories", url: "https://www.twodots.cloud/UseExecution", content: "Customer Case Studies. Outcomes, ROI, and implementation tips." }
    ]},
    // duplicate set (by design)
    { links: [
        { label: "Document Library", url: "https://www.twodots.cloud/UseExecution", content: "Document Library. Centralized repository of all documentation." },
        { label: "Knowledge Base", url: "https://www.twodots.cloud/UseExecution", content: "Knowledge Base. Searchable articles and guides." }
    ]},
    { links: [
        { label: "Training Center", url: "https://www.twodots.cloud/UseExecution", content: "Training Center. Interactive courses and learning materials." },
        { label: "Best Practices", url: "https://www.twodots.cloud/UseExecution", content: "Best Practices guide. Industry standards and recommendations." }
    ]},
    { links: [
        { label: "Resource Hub", url: "https://www.twodots.cloud/UseExecution", content: "Resource Hub. Tools, templates, and helpful resources." },
        { label: "Learning Paths", url: "https://www.twodots.cloud/UseExecution", content: "Learning Paths. Structured courses for skill development." }
    ]},
    { links: [
        { label: "Documentation", url: "https://www.twodots.cloud/UseExecution", content: "Documentation portal. Technical specs and API guides." },
        { label: "API Reference", url: "https://www.twodots.cloud/UseExecution", content: "API Reference. Complete API documentation and examples." }
    ]},
    { links: [
        { label: "Runbooks", url: "https://www.twodots.cloud/UseExecution", content: "Operational Runbooks. Step-by-step procedures for common tasks and incidents." },
        { label: "FAQs", url: "https://www.twodots.cloud/UseExecution", content: "Frequently Asked Questions. Curated answers to common queries." }
    ]},
    { links: [
        { label: "Architecture Diagrams", url: "https://www.twodots.cloud/UseExecution", content: "Architecture Library. System context, data flows, and component diagrams." },
        { label: "Style Guide", url: "https://www.twodots.cloud/UseExecution", content: "Editorial & Design Style Guide. Tone, typography, and UI conventions." }
    ]},
    { links: [
        { label: "Glossary", url: "https://www.twodots.cloud/UseExecution", content: "Company Glossary. Shared vocabulary and domain definitions." },
        { label: "Release Notes", url: "https://www.twodots.cloud/UseExecution", content: "Release Notes. Version changes, features, and fixes." }
    ]},
    { links: [
        { label: "ADRs", url: "https://www.twodots.cloud/UseExecution", content: "Architecture Decision Records. Context, decision, and consequences." },
        { label: "Onboarding Guide", url: "https://www.twodots.cloud/UseExecution", content: "New Hire Onboarding. First 90 days plan and learning checkpoints." }
    ]},
    { links: [
        { label: "Security Policies", url: "https://www.twodots.cloud/UseExecution", content: "Security Policies. Access control, secrets, and incident reporting." },
        { label: "Data Governance", url: "https://www.twodots.cloud/UseExecution", content: "Data Governance. Catalog, lineage, and quality standards." }
    ]},
    { links: [
        { label: "Partner Playbooks", url: "https://www.twodots.cloud/UseExecution", content: "Partner Playbooks. GTM motions, enablement, and integration guides." },
        { label: "Customer Stories", url: "https://www.twodots.cloud/UseExecution", content: "Customer Case Studies. Outcomes, ROI, and implementation tips." }
    ]}
  ],
  content: [
    { links: [
        { label: "AI Writer", url: "https://www.twodots.cloud/UseExecution", content: "AI Writer. Generate high-quality content with AI assistance." },
        { label: "Music Visualizer 🌟", url: "https://www.twodots.cloud/MusicVisualizer", content: "Visualize music as Art." }
    ]},
    { links: [
        { label: "Image Creator", url: "https://www.twodots.cloud/UseExecution", content: "Image Creator. AI-powered image generation and editing." },
        { label: "Video Editor", url: "https://www.twodots.cloud/UseExecution", content: "Video Editor. Professional video editing tools and effects." }
    ]},
    { links: [
        { label: "Social Posts", url: "https://www.twodots.cloud/UseExecution", content: "Social Posts manager. Schedule and publish across platforms." },
        { label: "Email Templates", url: "https://www.twodots.cloud/UseExecution", content: "Email Templates. Beautiful, responsive email designs." }
    ]},
    { links: [
        { label: "SEO Optimizer", url: "https://www.twodots.cloud/UseExecution", content: "SEO Optimizer. Improve search rankings and visibility." },
        { label: "Content Calendar", url: "https://www.twodots.cloud/UseExecution", content: "Content Calendar. Plan and organize your content strategy." }
    ]},
    { links: [
        { label: "Landing Page Builder", url: "https://www.twodots.cloud/UseExecution", content: "Landing Page Builder. Ship high-converting pages without code." },
        { label: "Ad Copy Generator", url: "https://www.twodots.cloud/UseExecution", content: "Ad Copy Generator. Multi-platform variants optimized for CTR and CPA." }
    ]},
    { links: [
        { label: "Brand Guidelines", url: "https://www.twodots.cloud/UseExecution", content: "Brand Guidelines. Voice, visuals, and usage rules in one place." },
        { label: "Case Study Templates", url: "https://www.twodots.cloud/UseExecution", content: "Case Study Templates. Narrative frames and ROI calculators." }
    ]},
    { links: [
        { label: "Press Kit", url: "https://www.twodots.cloud/UseExecution", content: "Press Kit. Logos, bios, and media assets for journalists." },
        { label: "Webinar Kit", url: "https://www.twodots.cloud/UseExecution", content: "Webinar Kit. Slide templates, scripts, and follow-up flows." }
    ]},
    { links: [
        { label: "Podcast Notes", url: "https://www.twodots.cloud/UseExecution", content: "Podcast Show Notes. Summaries, timestamps, and pull quotes." },
        { label: "Infographic Creator", url: "https://www.twodots.cloud/UseExecution", content: "Infographic Creator. Data stories with vector exports." }
    ]},
    { links: [
        { label: "Localization", url: "https://www.twodots.cloud/UseExecution", content: "Localization Hub. Translate and adapt content for new markets." },
        { label: "Content QA", url: "https://www.twodots.cloud/UseExecution", content: "Content QA. Grammar, compliance, and brand consistency checks." }
    ]},
    { links: [
        { label: "Asset Library", url: "https://www.twodots.cloud/UseExecution", content: "Asset Library. Versioned storage for images, video, and copy." },
        { label: "Distribution Hub", url: "https://www.twodots.cloud/UseExecution", content: "Distribution Hub. Omnichannel publishing and UTMs." }
    ]},
    // duplicate set (by design)
    { links: [
        { label: "AI Writer", url: "https://www.twodots.cloud/UseExecution", content: "AI Writer. Generate high-quality content with AI assistance." },
        { label: "Music Visualizer 🌟", url: "https://www.twodots.cloud/MusicVisualizer", content: "Visualize music as Art." }
    ]},
    { links: [
        { label: "Image Creator", url: "https://www.twodots.cloud/UseExecution", content: "Image Creator. AI-powered image generation and editing." },
        { label: "Video Editor", url: "https://www.twodots.cloud/UseExecution", content: "Video Editor. Professional video editing tools and effects." }
    ]},
    { links: [
        { label: "Social Posts", url: "https://www.twodots.cloud/UseExecution", content: "Social Posts manager. Schedule and publish across platforms." },
        { label: "Email Templates", url: "https://www.twodots.cloud/UseExecution", content: "Email Templates. Beautiful, responsive email designs." }
    ]},
    { links: [
        { label: "SEO Optimizer", url: "https://www.twodots.cloud/UseExecution", content: "SEO Optimizer. Improve search rankings and visibility." },
        { label: "Content Calendar", url: "https://www.twodots.cloud/UseExecution", content: "Content Calendar. Plan and organize your content strategy." }
    ]},
    { links: [
        { label: "Landing Page Builder", url: "https://www.twodots.cloud/UseExecution", content: "Landing Page Builder. Ship high-converting pages without code." },
        { label: "Ad Copy Generator", url: "https://www.twodots.cloud/UseExecution", content: "Ad Copy Generator. Multi-platform variants optimized for CTR and CPA." }
    ]},
    { links: [
        { label: "Brand Guidelines", url: "https://www.twodots.cloud/UseExecution", content: "Brand Guidelines. Voice, visuals, and usage rules in one place." },
        { label: "Case Study Templates", url: "https://www.twodots.cloud/UseExecution", content: "Case Study Templates. Narrative frames and ROI calculators." }
    ]},
    { links: [
        { label: "Press Kit", url: "https://www.twodots.cloud/UseExecution", content: "Press Kit. Logos, bios, and media assets for journalists." },
        { label: "Webinar Kit", url: "https://www.twodots.cloud/UseExecution", content: "Webinar Kit. Slide templates, scripts, and follow-up flows." }
    ]},
    { links: [
        { label: "Podcast Notes", url: "https://www.twodots.cloud/UseExecution", content: "Podcast Show Notes. Summaries, timestamps, and pull quotes." },
        { label: "Infographic Creator", url: "https://www.twodots.cloud/UseExecution", content: "Infographic Creator. Data stories with vector exports." }
    ]},
    { links: [
        { label: "Localization", url: "https://www.twodots.cloud/UseExecution", content: "Localization Hub. Translate and adapt content for new markets." },
        { label: "Content QA", url: "https://www.twodots.cloud/UseExecution", content: "Content QA. Grammar, compliance, and brand consistency checks." }
    ]},
    { links: [
        { label: "Asset Library", url: "https://www.twodots.cloud/UseExecution", content: "Asset Library. Versioned storage for images, video, and copy." },
        { label: "Distribution Hub", url: "https://www.twodots.cloud/UseExecution", content: "Distribution Hub. Omnichannel publishing and UTMs." }
    ]}
  ],
  chat: [
    { links: [
        { label: "AI Assistant", url: "https://www.twodots.cloud/UseExecution", content: "AI Assistant. Intelligent conversational AI for your applications." },
        { label: "Chat Interface", url: "https://www.twodots.cloud/UseExecution", content: "Chat Interface. Customizable chat UI components." }
    ]},
    { links: [
        { label: "Data Query", url: "https://www.twodots.cloud/UseExecution", content: "Data Query. Natural language database queries." },
        { label: "SQL Builder", url: "https://www.twodots.cloud/UseExecution", content: "SQL Builder. Visual SQL query construction tool." }
    ]},
    { links: [
        { label: "Voice Interface", url: "https://www.twodots.cloud/UseExecution", content: "Voice Interface. Voice-enabled conversational experiences." },
        { label: "Chatbot Builder", url: "https://www.twodots.cloud/UseExecution", content: "Chatbot Builder. Create custom chatbots without coding." }
    ]},
    { links: [
        { label: "Conversational AI", url: "https://www.twodots.cloud/UseExecution", content: "Conversational AI. Advanced natural language processing." },
        { label: "Smart Replies", url: "https://www.twodots.cloud/UseExecution", content: "Smart Replies. AI-suggested response generation." }
    ]},
    { links: [
        { label: "RAG Search", url: "https://www.twodots.cloud/UseExecution", content: "Retrieval-Augmented Generation. Grounded answers over your docs." },
        { label: "Live Agent Handoff", url: "https://www.twodots.cloud/UseExecution", content: "Handoff Orchestrator. Seamless transfer to human support with context." }
    ]},
    { links: [
        { label: "Chat Analytics", url: "https://www.twodots.cloud/UseExecution", content: "Analytics & Transcripts. Intent coverage, CSAT, and topic drift." },
        { label: "Multilingual Chat", url: "https://www.twodots.cloud/UseExecution", content: "Multilingual Translation. Real-time language detection and swap." }
    ]},
    { links: [
        { label: "Safety Moderation", url: "https://www.twodots.cloud/UseExecution", content: "Safety Layer. Toxicity filters, PII redaction, and policy routing." },
        { label: "Feedback Loop", url: "https://www.twodots.cloud/UseExecution", content: "Feedback Collection. Thumb ratings, explanations, and re-train cues." }
    ]},
    { links: [
        { label: "Context Memory", url: "https://www.twodots.cloud/UseExecution", content: "Conversation Memory. Short/long-term memory with privacy controls." },
        { label: "Form Filler", url: "https://www.twodots.cloud/UseExecution", content: "Form Automation. Extract, validate, and submit structured data." }
    ]},
    { links: [
        { label: "Agent Routing", url: "https://www.twodots.cloud/UseExecution", content: "Agent Router. Skill-based routing and multi-agent collaboration." },
        { label: "Proactive Outreach", url: "https://www.twodots.cloud/UseExecution", content: "Proactive Messaging. Event-driven nudges and lifecycle triggers." }
    ]},
    { links: [
        { label: "Knowledge Sync", url: "https://www.twodots.cloud/UseExecution", content: "Knowledge Sync. Index support docs, wikis, and product updates." },
        { label: "Sandbox Tools", url: "https://www.twodots.cloud/UseExecution", content: "Tool Use & Functions. Secure actions with audit logs." }
    ]},
    // duplicate set (by design)
    { links: [
        { label: "AI Assistant", url: "https://www.twodots.cloud/UseExecution", content: "AI Assistant. Intelligent conversational AI for your applications." },
        { label: "Chat Interface", url: "https://www.twodots.cloud/UseExecution", content: "Chat Interface. Customizable chat UI components." }
    ]},
    { links: [
        { label: "Data Query", url: "https://www.twodots.cloud/UseExecution", content: "Data Query. Natural language database queries." },
        { label: "SQL Builder", url: "https://www.twodots.cloud/UseExecution", content: "SQL Builder. Visual SQL query construction tool." }
    ]},
    { links: [
        { label: "Voice Interface", url: "https://www.twodots.cloud/UseExecution", content: "Voice Interface. Voice-enabled conversational experiences." },
        { label: "Chatbot Builder", url: "https://www.twodots.cloud/UseExecution", content: "Chatbot Builder. Create custom chatbots without coding." }
    ]},
    { links: [
        { label: "Conversational AI", url: "https://www.twodots.cloud/UseExecution", content: "Conversational AI. Advanced natural language processing." },
        { label: "Smart Replies", url: "https://www.twodots.cloud/UseExecution", content: "Smart Replies. AI-suggested response generation." }
    ]},
    { links: [
        { label: "RAG Search", url: "https://www.twodots.cloud/UseExecution", content: "Retrieval-Augmented Generation. Grounded answers over your docs." },
        { label: "Live Agent Handoff", url: "https://www.twodots.cloud/UseExecution", content: "Handoff Orchestrator. Seamless transfer to human support with context." }
    ]},
    { links: [
        { label: "Chat Analytics", url: "https://www.twodots.cloud/UseExecution", content: "Analytics & Transcripts. Intent coverage, CSAT, and topic drift." },
        { label: "Multilingual Chat", url: "https://www.twodots.cloud/UseExecution", content: "Multilingual Translation. Real-time language detection and swap." }
    ]},
    { links: [
        { label: "Safety Moderation", url: "https://www.twodots.cloud/UseExecution", content: "Safety Layer. Toxicity filters, PII redaction, and policy routing." },
        { label: "Feedback Loop", url: "https://www.twodots.cloud/UseExecution", content: "Feedback Collection. Thumb ratings, explanations, and re-train cues." }
    ]},
    { links: [
        { label: "Context Memory", url: "https://www.twodots.cloud/UseExecution", content: "Conversation Memory. Short/long-term memory with privacy controls." },
        { label: "Form Filler", url: "https://www.twodots.cloud/UseExecution", content: "Form Automation. Extract, validate, and submit structured data." }
    ]},
    { links: [
        { label: "Agent Routing", url: "https://www.twodots.cloud/UseExecution", content: "Agent Router. Skill-based routing and multi-agent collaboration." },
        { label: "Proactive Outreach", url: "https://www.twodots.cloud/UseExecution", content: "Proactive Messaging. Event-driven nudges and lifecycle triggers." }
    ]},
    { links: [
        { label: "Knowledge Sync", url: "https://www.twodots.cloud/UseExecution", content: "Knowledge Sync. Index support docs, wikis, and product updates." },
        { label: "Sandbox Tools", url: "https://www.twodots.cloud/UseExecution", content: "Tool Use & Functions. Secure actions with audit logs." }
    ]}
  ]
};


function ExperiencesPage({
  onLaunchUseExecution,
  onLaunchCompanyResearch,
  onLaunchFindJobs,
  onLaunchMusicVisualizer
}) {
  const [activeCategory, setActiveCategory] = useState("research");
  const [selectedContent, setSelectedContent] = useState(null);
  const [settings] = useState({
    radius: 100,
    speed: 60,
    fontSize: 12,
    gap: 200,
    direction: "clockwise",
    pauseOnHover: true,
    keepTextUpright: true,
    showSpokes: true,
    rightPanelWidth: 600
  });

  const spokes = spokesData[activeCategory];
  const spokeCount = spokes.length;
  const angleStep = 360 / spokeCount;

  const radialDistances = useMemo(() =>
    (spokes[0]?.links || []).map((_, i) => settings.radius + 10 + (settings.gap * i)),
    [spokes, settings.radius, settings.gap]
  );

  const handleLinkClick = (e, link) => {
    e.preventDefault();
    setSelectedContent(link);
  };

  const containerStyle = {
    ...styles.experienceShell,
    gridTemplateColumns: `320px minmax(0, 1fr) ${settings.rightPanelWidth}px`,
    marginTop: -16
  };

  return (
    <div style={containerStyle}>
        <style>{`
          @keyframes rotate-wheel { from { transform: rotate(0deg); } to { transform: rotate(${settings.direction === 'clockwise' ? '360deg' : '-360deg'}); } }
          @keyframes counter-rotate { from { transform: rotate(0deg); } to { transform: rotate(${settings.direction === 'clockwise' ? '-360deg' : '360deg'}); } }
          .wheel-container { animation: rotate-wheel ${settings.speed}s linear infinite; transform-origin:center center; }
          .wheel-container:hover { ${settings.pauseOnHover ? 'animation-play-state: paused;' : ''} }
          .link-pill { will-change: transform; }
          .link-text { ${settings.keepTextUpright ? `animation: counter-rotate ${settings.speed}s linear infinite;` : ''} }
          .link-text.paused { ${settings.pauseOnHover ? 'animation-play-state: paused;' : ''} }
        `}</style>

        <div style={styles.leftPanel}>
          <div style={styles.panelContent}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
              {[
                { id: 'research', icon: '', label: 'Research & Insights' },
                { id: 'workflows', icon: '', label: 'Dynamic Workflows' },
                { id: 'knowledge', icon: '', label: 'Knowledge' },
                { id: 'content', icon: '', label: 'Content Generation' },
                { id: 'chat', icon: '', label: 'Conversational Data Access' }
              ].map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => {
                    setActiveCategory(cat.id);
                    setSelectedContent(null);
                  }}
                  style={{
                    ...styles.navBtn,
                    background: activeCategory === cat.id ? 'rgba(100,120,255,0.2)' : 'rgba(255,255,255,0.05)',
                    borderColor: activeCategory === cat.id ? 'rgba(100,120,255,0.4)' : 'rgba(255,255,255,0.1)'
                  }}
                >
                  <span>{cat.icon}</span>
                  <span>{cat.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        <div style={styles.stage}>
          <div
            className="wheel-container"
            style={{
              position: 'relative',
              width: settings.radius * 2,
              height: settings.radius * 2,
              transformOrigin: '50% 50%',
              marginLeft: -settings.radius
            }}
          >
            <div
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                width: 22,
                height: 22,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.35)',
                transform: 'translate(-50%, -50%)',
                zIndex: 2
              }}
            />

            {spokes.map((spoke, idx) => {
              const angle = idx * angleStep;
              return (
                <Spoke
                  key={idx}
                  angle={angle}
                  radius={settings.radius}
                  links={spoke.links}
                  radialDistances={radialDistances}
                  fontSize={settings.fontSize}
                  gap={settings.gap}
                  keepTextUpright={settings.keepTextUpright}
                  speed={settings.speed}
                  pauseOnHover={settings.pauseOnHover}
                  onLinkClick={handleLinkClick}
                  showSpokes={settings.showSpokes}
                  selectedContent={selectedContent}
                />
              );
            })}
          </div>
        </div>

        <div style={styles.rightPanel}>
          {selectedContent ? (
            <div style={styles.contentBox}>
              <div style={styles.contentHeader}>
                <h2 style={styles.contentTitle}>{selectedContent.label}</h2>
                <button onClick={() => setSelectedContent(null)} style={styles.closeBtn}>
                  ✕
                </button>
              </div>
              <div style={styles.contentBody}>
                <p style={styles.contentText}>{selectedContent.content}</p>
                  <button
                    type="button"
                    onClick={() => {
                      const label = selectedContent?.label?.toLowerCase() ?? "";
                      if (label.includes("customer insights")) {
                        onLaunchCompanyResearch?.();
                      } else {
                        onLaunchUseExecution?.();
                      }
                    }}
                    style={styles.contentLinkButton}
                  >
                    Visit {selectedContent.label} →
                  </button>
              </div>
            </div>
          ) : (
            <div style={styles.emptyState}>
              <div style={styles.emptyIcon}>🎯</div>
              <h3 style={styles.emptyTitle}>Select a Resource</h3>
              <p style={styles.emptyText}>Click on any link in the wheel to view its content here</p>
            </div>
          )}
          <div style={styles.findJobsCallout}>
            <p style={styles.calloutTitle}>Capture job board context</p>
            <p style={styles.calloutText}>
              Launch the Find Jobs capture workspace so you can instrument the iframe with extensions
              or a bookmarklet that ties into the FlexRec schema.
            </p>
            <button
              type="button"
              style={styles.calloutButton}
              onClick={() => onLaunchFindJobs?.()}
            >
              Open Find Jobs Capture
            </button>
          </div>
          <div style={styles.musicVisualizerCallout}>
            <p style={styles.calloutTitle}>Visualize music data</p>
            <p style={styles.calloutText}>
              Open the Music Visualizer to feed audio through the Web Audio analyzer, stream the spectrum,
              and make pointers or particles react inside the canvas.
            </p>
            <button
              type="button"
              style={styles.calloutButton}
              onClick={() => onLaunchMusicVisualizer?.()}
            >
              Launch Music Visualizer
            </button>
          </div>
        </div>
    </div>
  );
}

function Spoke({ angle, radius, links, radialDistances, fontSize, gap, keepTextUpright, speed, pauseOnHover, onLinkClick, showSpokes, selectedContent }) {
  return (
    <div
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: radius + 300,
        height: 0,
        transform: `rotate(${angle}deg)`,
        transformOrigin: '0% 50%'
      }}
    >
      {showSpokes && (
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: -1,
          width: radius,
          height: 2,
          background: `linear-gradient(90deg, ${EXPERIENCE_BRAND_COLOR}CC, rgba(184,111,255,0.15))`
        }}
      />
      )}

      {links.map((link, i) => {
        const r = radialDistances[i] ?? (radius + 10 + gap * i);
        const isSelected = selectedContent && selectedContent.label === link.label && selectedContent.url === link.url;
        return (
          <div
            key={i}
            className="link-pill"
            style={{
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: `translateY(-50%) translateX(${r}px)`,
              transformOrigin: '0% 50%'
            }}
          >
            <a
              href={link.url}
              onClick={(e) => onLinkClick(e, link)}
              className={"link-text" + (pauseOnHover ? ' paused' : '')}
              style={{
                display: 'inline-block',
                fontSize,
                color: '#e8ebff',
                textDecoration: 'none',
                padding: '6px 12px',
                borderRadius: 20,
              background: isSelected ? 'rgba(184,111,255,0.35)' : 'rgba(255,255,255,0.03)',
              border: isSelected ? `1px solid ${EXPERIENCE_BRAND_COLOR}` : '1px solid rgba(255,255,255,0.18)',
                whiteSpace: 'nowrap',
                transition: 'transform 120ms ease, background 120ms ease, box-shadow 120ms ease',
                cursor: 'pointer',
                boxShadow: isSelected ? '0 0 20px rgba(100,120,255,0.4)' : 'none'
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.18)';
                }
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.25)';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                  e.currentTarget.style.boxShadow = 'none';
                } else {
                  e.currentTarget.style.boxShadow = '0 0 20px rgba(100,120,255,0.4)';
                }
                e.currentTarget.style.transform = 'none';
              }}
            >
              {link.label}
            </a>
          </div>
        );
      })}
    </div>
  );
}

const styles = {
  experienceShell: {
    width: '100%',
    display: 'grid',
    minHeight: '80vh',
    gap: 0,
    alignItems: 'stretch',
    padding: '0 16px 32px'
  },
  leftPanel: {
    padding: 24,
    background: 'transparent',
    backdropFilter: 'blur(20px)',
    overflowY: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  panelContent: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' },
  leftPanelLogo: {
    width: 180,
    maxWidth: '90%',
    marginBottom: 24,
    display: 'block'
  },
  h1: { margin: 0, fontSize: 28, fontWeight: 700, color: '#e8ebff' },
  subtitle: { opacity: 0.8, marginTop: 6, fontSize: 13, color: '#a8b3ff' },
  h2: { marginTop: 30, marginBottom: 16, fontSize: 18, color: '#a8b3ff' },
  navBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 16px',
    minWidth: 220,
    width: 260,
    borderRadius: 8,
    border: '1px solid',
    cursor: 'pointer',
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
    transition: 'all 0.2s ease',
    gap: 6
  },
  stage: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: '100vh',
    overflow: 'hidden',
    background: 'transparent',
    borderRadius: 24,
    margin: 0,
    backdropFilter: 'blur(20px)'
  },
  rightPanel: {
    padding: 24,
    borderLeft: '1px solid rgba(255,255,255,0.1)',
    background: 'transparent',
    backdropFilter: 'blur(20px)',
    overflowY: 'auto'
  },
  contentBox: {
    background: 'rgba(255,255,255,0.05)',
    borderRadius: 12,
    border: '1px solid rgba(255,255,255,0.1)',
    overflow: 'hidden'
  },
  contentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
    background: 'rgba(255,255,255,0.03)'
  },
  contentTitle: {
    margin: 0,
    fontSize: 20,
    fontWeight: 600,
    color: '#e8ebff'
  },
  closeBtn: {
    background: 'rgba(255,255,255,0.1)',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: 6,
    color: '#e8ebff',
    cursor: 'pointer',
    fontSize: 16,
    padding: '6px 12px',
    transition: 'all 0.2s ease'
  },
  contentBody: {
    padding: 24
  },
  contentText: {
    color: '#c5d0ff',
    fontSize: 15,
    lineHeight: 1.6,
    marginBottom: 20
  },
  contentLinkButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 20px',
    background: 'rgba(184,111,255,0.15)',
    border: `1px solid ${EXPERIENCE_BRAND_COLOR}`,
    borderRadius: 8,
    color: '#e8ebff',
    fontSize: 14,
    fontWeight: 500,
    transition: 'all 0.2s ease',
    cursor: 'pointer'
  },
  findJobsCallout: {
    marginTop: 24,
    padding: 16,
    borderRadius: 14,
    border: '1px dashed rgba(255,255,255,0.25)',
    background: 'rgba(255,255,255,0.02)',
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  musicVisualizerCallout: {
    marginTop: 12,
    padding: 16,
    borderRadius: 14,
    border: '1px solid rgba(184,111,255,0.35)',
    background: 'rgba(184,111,255,0.06)',
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  calloutTitle: {
    margin: 0,
    fontSize: 14,
    fontWeight: 600,
    color: '#b86fff'
  },
  calloutText: {
    margin: 0,
    fontSize: 12,
    color: 'rgba(255,255,255,0.7)'
  },
  calloutButton: {
    alignSelf: 'flex-start',
    padding: '8px 16px',
    borderRadius: 999,
    border: '1px solid rgba(255,255,255,0.5)',
    background: 'rgba(184,111,255,0.15)',
    color: '#fff',
    cursor: 'pointer',
    fontSize: 12,
    letterSpacing: 0.5
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: 400,
    textAlign: 'center',
    padding: 40
  },
  emptyIcon: {
    fontSize: 64,
    marginBottom: 20,
    opacity: 0.6
  },
  emptyTitle: {
    margin: 0,
    marginBottom: 12,
    fontSize: 22,
    fontWeight: 600,
    color: '#e8ebff'
  },
  emptyText: {
    margin: 0,
    fontSize: 15,
    color: '#a8b3ff',
    opacity: 0.8
  },
};

export default ExperiencesPage;
